export type State = {
  calling: string[];
  isInternetAvailable: boolean;
  errorMessage: string;
  status: string;
  displayError: boolean;
};

const initialState: State = {
  calling: [],
  isInternetAvailable: true,
  errorMessage: '',
  status: '',
  displayError: false
};

const Network = (state: State = initialState, action: any) => {
  let newCalling;
  console.log(action.type, action);
  switch (action.type) {
    case 'START_CALLING':
      state.calling.push(action.apiTitle);
      return {
        ...state,
        calling: state.calling,
        status: '',
        errorMessage: ''
      };

    case 'FINISH_CALLING':
      newCalling = state.calling.filter(title => title !== action.apiTitle);
      return {
        ...state,
        calling: newCalling,
        status: 'success'
      };

    case 'FAIL_CALLING':
      newCalling = state.calling.filter(title => title !== action.apiTitle);
      return {
        ...state,
        calling: newCalling,
        errorMessage: action.errorMessage,
        status: 'fail',
        displayError: true
      };

    case 'SERVER_ERROR_CALLING':
      newCalling = state.calling.filter(title => title !== action.apiTitle);
      return {
        ...state,
        calling: newCalling,
        errorMessage: 'サーバーエラーが発生しました',
        status: 'fail',
        displayError: true
      };

    case 'CLEAR_ERROR_MESSAGE':
      return {
        ...state,
        errorMessage: ''
      };

    case 'LOGOUT_USER':
      return {
        ...state,
        errorMessage: ''
      };
  }
  return state;
};
export default Network;



// WEBPACK FOOTER //
// ./src/reducers/Network.ts